/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch } from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { Heading, Box, Text, FlexContainer, Button } from "@nordcloud/gnui";
import { DataDisplayWrapper } from "~/components";
import { useApplicationWizard } from "./ApplicationProvider";
import { State } from "./types";

type Props = {
  updateState: Dispatch<Partial<State>>;
};

export function ConfirmAndFinalize({ updateState }: Props) {
  const { applicationData } = useApplicationWizard();

  return (
    <>
      <Row justify="center">
        <Col sm={8} md={8} lg={10}>
          <Heading marginBottom="spacing04" level={4}>
            Application Details
          </Heading>
          <Box boxStyle="lightGrey" spacing="spacing04">
            <FlexContainer alignItems="start" justifyContent="space-between">
              <div css={{ flex: "1" }}>
                <Text size="sm" mb={0}>
                  Application Name
                </Text>
                <DataDisplayWrapper
                  hasData={applicationData?.name !== undefined}
                >
                  <p css={{ wordBreak: "break-all" }}>
                    {applicationData?.name}
                  </p>
                </DataDisplayWrapper>
                <Text size="sm" mb={0}>
                  Application Owner
                </Text>
                <DataDisplayWrapper
                  hasData={applicationData?.owner !== undefined}
                >
                  {applicationData?.owner}
                </DataDisplayWrapper>
                <Text size="sm" mb={0}>
                  Contact Person
                </Text>
                <DataDisplayWrapper
                  hasData={applicationData?.contactPerson !== undefined}
                >
                  {applicationData?.contactPerson}
                </DataDisplayWrapper>
                <Text size="sm" mb={0}>
                  Description
                </Text>
                <DataDisplayWrapper
                  hasData={
                    applicationData?.description !== undefined &&
                    applicationData?.description !== ""
                  }
                >
                  <p css={{ wordBreak: "break-all" }}>
                    {applicationData?.description}
                  </p>
                </DataDisplayWrapper>
              </div>
              <div>
                <Button
                  aria-label="edit button"
                  icon="edit"
                  size="md"
                  severity="low"
                  onClick={() => updateState({ currentStep: 0 })}
                />
              </div>
            </FlexContainer>
          </Box>
        </Col>
      </Row>
    </>
  );
}
